import { PageNumber } from "../styles.ts";
import * as S from "./styles.ts";
import { useState } from "react";
import useBreakpoint from "@/lib/helpers/useBreakpoint.ts";

interface IPagesProps {
  pages: number;
  selectedPage: number;
  onChange: (val: number) => void;
}

const Pages = ({ pages, selectedPage, onChange }: IPagesProps) => {
  const { check: isBig } = useBreakpoint("md");
  const isSm = !isBig;

  const Page = ({ page }: { page: number }) => (
    <PageNumber
      $selected={selectedPage === page}
      onClick={() => onChange(page)}
    >
      {page + 1}
    </PageNumber>
  );

  const CustomPage = () => {
    const [customPage, setCustomPage] = useState("");

    const handleCustomPage = () => {
      const numberVal = Number(customPage);
      onChange(Math.min(Math.max(0, numberVal - 1), pages - 1));
    };

    return (
      <S.CustomPageInput
        placeholder="..."
        type="number"
        max={pages}
        value={customPage}
        onChange={(e) =>
          setCustomPage(
            Math.max(1, Math.min(pages, Number(e.target.value))).toString(),
          )
        }
        min={1}
        onKeyDown={(e) => e.key === "Enter" && handleCustomPage()}
        onBlur={handleCustomPage}
      />
    );
  };

  const aroundPages = (
    selectedPage === 0
      ? [1, 2, 3]
      : selectedPage === 1
        ? [1, 2, 3]
        : selectedPage === pages - 2
          ? [pages - 4, pages - 3, pages - 2]
          : selectedPage === pages - 1
            ? [pages - 4, pages - 3, pages - 2]
            : [selectedPage - 1, selectedPage, selectedPage + 1]
  ).filter((page) => page > 0 && page < pages - 1);

  if (isSm)
    return (
      <>
        <Page page={0} />
        {![0, pages - 1].includes(selectedPage) && <Page page={selectedPage} />}
        {pages > 1 && <CustomPage />}
        {pages > 1 && <Page page={pages - 1} />}
      </>
    );

  return (
    <>
      <Page page={0} />
      {selectedPage > 2 && <CustomPage />}
      {aroundPages.map((page) => (
        <Page
          key={page}
          page={page}
        />
      ))}
      {selectedPage < pages - 3 && pages > 5 && <CustomPage />}
      {pages > 1 && <Page page={pages - 1} />}
    </>
  );
};

export default Pages;
